'use strict';

angular.module('internal.licenses')
    .controller('InternalLicense', ['$scope', '$stateParams', 'Licenses', 'ViewedLicenses', 'Cache', function ($scope, $stateParams, Licenses, ViewedLicenses, Cache) {
        $scope.masterLicense = $stateParams.license;
        $scope.license = $stateParams.license;
        $scope.licenseID = $stateParams.id;
        $scope.licenseLoading = true;
        $scope.showScheduledTasks = false;

        if ($scope.enterprise != null && $scope.enterprise.show_scheduled_tasks_in_license != null) {
            $scope.showScheduledTasks = $scope.enterprise.show_scheduled_tasks_in_license;
        }

        $scope.setMasterLicense = function (license) {
            $scope.masterLicense = license;
            $scope.license = angular.copy($scope.masterLicense);
            $scope.licenseCategoryID = $scope.license.license_category_id;
        }

        $scope.resetLicense = function () {
            if ($scope.masterLicense == null) {
                $scope.masterLicense = {};
            }
            $scope.license = angular.copy($scope.masterLicense);
        }

        if ($stateParams.id != null) {
            //Cache.get('license', $stateParams.id).then(function (license) {
            //    if ($scope.licenseLoading) {
            //        if (license != null) {
            //            $scope.license = license;
            //            $scope.license.fromCache = true;
            //        }
            //    }
            //})

            Licenses.getByID($stateParams.id).then(function (license) {
                $scope.licenseLoading = false;
                $scope.setMasterLicense(license);
                //if (license != null) {
                //    Cache.save('license', license);
                //}
            })

            //log time in License_Views
            //calls the service
            //passes is license ID
            ViewedLicenses.save($stateParams.id);
        }
        else {
            var license = {};
            Licenses.get().then(function (licenses) {
                license.sort_order = Math.max.apply(Math, licenses.map(function (l) { return l.sort_order; })) + 1;
                license.training_validation_type = 'validate_duration'
                license.license_request_statuses = [];
                license.license_rules = [];
                license.license_category_levels = [];
                license.license_category_certification_statuses = [];
                license.license_category_certification_attributes = [];
                $scope.licenseLoading = false;
                $scope.setMasterLicense(license);
            });
        }
    }])
    ;